import { createRouter, createWebHistory } from 'vue-router'

import Invite from './views/unregistered/Invite.vue'
import Register from './views/unregistered/Register.vue'
import Login from './views/unregistered/Login.vue'

import UserWireguard from './views/registered/user/Wireguard.vue'
import UserSocks from './views/registered/user/Socks.vue'
import UserMTProxy from './views/registered/user/MTProxy.vue'
import Instruction from './views/registered/user/Instruction.vue'
import UserHealthCheck from './views/registered/user/HealthCheck.vue'

import Invitations from './views/registered/admin/Invitations.vue'
import Users from './views/registered/admin/Users.vue'
import AdminWireguard from './views/registered/admin/Wireguard.vue'
import AdminSocks from './views/registered/admin/Socks.vue'
import AdminMTProxy from './views/registered/admin/MTProxy.vue'

const routes = [
	{
		path: '/invite',
		name: 'Invite',
		component: Invite
	},
	{
		path: '/register/:invitationToken?',
		name: 'Register',
		component: Register,
		props: true
	},
	{
		path: '/',
		name: 'Login',
		component: Login
	},
	/* user */
	{
		path: '/user',
		redirect: '/user/wireguard'
	},
	{
		path: '/user/wireguard',
		name: 'UserWireguard',
		component: UserWireguard
	},
	{
		path: '/user/socks',
		name: 'UserSocks',
		component: UserSocks
	},
	{
		path: '/user/mtproxy',
		name: 'UserMTProxy',
		component: UserMTProxy
	},
	{
		path: '/user/instruction',
		name: 'Instruction',
		component: Instruction
	},
	{
		path: '/user/health',
		name: 'UserHealthCheck',
		component: UserHealthCheck
	},
	/* admin */
	{
		path: '/admin',
		redirect: '/admin/wireguard'
	},
	{
		path: '/admin/invitations',
		name: 'Invitations',
		component: Invitations
	},
	{
		path: '/admin/users',
		name: 'Users',
		component: Users
	},
	{
		path: '/admin/wireguard',
		name: 'AdminWireguard',
		component: AdminWireguard
	},
	{
		path: '/admin/socks',
		name: 'AdminSocks',
		component: AdminSocks
	},
	{
		path: '/admin/mtproxy',
		name: 'AdminMTProxy',
		component: AdminMTProxy
	},
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router